/* Progressive review filtering and original-photo zoom; no external requests. */
(function () {
  'use strict';
  if (window.mtReviewFeed) { window.mtReviewFeed.mount(document); return; }

  function initialise(root) {
    if (root.dataset.reviewReady) return;
    const cards = Array.from(root.querySelectorAll('.mt-rv-grid .mt-rv-card'));
    if (!cards.length) return;
    root.dataset.reviewReady = 'true';
    const pageSize = Number(root.dataset.perPage) || 8;
    const more = root.querySelector('[data-mt-rv-more]');
    const tools = root.querySelector('[data-review-tools]');
    const status = root.querySelector('[data-review-status]');
    const clear = root.querySelector('[data-rating-clear]');
    const empty = root.querySelector('[data-rating-empty]');
    const ratingButtons = Array.from(root.querySelectorAll('[data-rating-filter]'));
    const photoButtons = Array.from(root.querySelectorAll('[data-review-photos]'));
    const strip = root.querySelector('[data-review-strip]');
    const thumbnails = Array.from(root.querySelectorAll('.mt-rv-strip__item'));
    let rating = null, photosOnly = false, limit = pageSize;

    function matches(card) {
      return (rating === null || Number(card.dataset.rating) === rating) && (!photosOnly || card.dataset.hasPhoto === 'true');
    }
    function filtered() { return cards.filter(matches); }
    function render() {
      const matching = filtered();
      cards.forEach(function (card) { card.hidden = true; });
      matching.slice(0, limit).forEach(function (card) { card.hidden = false; });
      if (more) more.parentElement.hidden = matching.length <= limit;
      if (empty) empty.hidden = matching.length > 0;
      if (clear) clear.hidden = rating === null && !photosOnly;
      if (status) status.textContent = 'Showing ' + Math.min(limit, matching.length) + ' of ' + matching.length + ' review' + (matching.length === 1 ? '' : 's') + (rating === null ? '' : ' rated ' + rating + ' stars') + (photosOnly ? ' with photographs' : '') + '.';
      ratingButtons.forEach(function (button) { button.setAttribute('aria-pressed', String(Number(button.dataset.ratingFilter) === rating)); });
      photoButtons.forEach(function (button) { button.setAttribute('aria-pressed', String((button.dataset.reviewPhotos === 'photos') === photosOnly)); });
      const photoIndexes = new Set(matching.filter(function (card) { return card.dataset.hasPhoto === 'true'; }).map(function (card) { return card.dataset.photoIdx; }));
      thumbnails.forEach(function (thumbnail) { thumbnail.hidden = !photoIndexes.has(thumbnail.dataset.mtRvOpen); });
      if (strip) strip.hidden = photoIndexes.size < 2;
    }
    ratingButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        rating = Number(button.dataset.ratingFilter); limit = pageSize; render();
        const overall = root.querySelector('.mt-rv-overall');
        if (overall) { overall.open = false; overall.querySelector('summary').focus({ preventScroll:true }); }
      });
    });
    photoButtons.forEach(function (button) { button.addEventListener('click', function () { photosOnly = button.dataset.reviewPhotos === 'photos'; limit = pageSize; render(); }); });
    if (clear) clear.addEventListener('click', function () { rating = null; photosOnly = false; limit = pageSize; render(); });
    if (more) more.addEventListener('click', function () {
      const next = filtered()[limit]; limit += pageSize; render();
      if (next) { next.tabIndex = -1; next.focus({ preventScroll:false }); }
    });
    render();
    if (tools) tools.hidden = false;

    const modal = root.querySelector('.mt-rv-modal');
    if (!modal || typeof modal.showModal !== 'function') return;
    const image = modal.querySelector('[data-mt-rv-img]');
    const content = modal.querySelector('[data-mt-rv-review]');
    const position = modal.querySelector('[data-mt-rv-pos]');
    const previous = modal.querySelector('[data-mt-rv-prev]');
    const next = modal.querySelector('[data-mt-rv-next]');
    let photoCards = [], active = 0, lastFocus = null, previousOverflow = '';
    function show(index) {
      if (!photoCards.length) return;
      active = (index + photoCards.length) % photoCards.length;
      const card = photoCards[active];
      image.src = card.dataset.full;
      const author = card.querySelector('.mt-rv-card__name');
      image.alt = 'Original customer photograph' + (author ? ' from ' + author.textContent + "'s review" : '');
      content.replaceChildren(card.querySelector('.mt-rv-card__main').cloneNode(true));
      if (position) position.textContent = (active + 1) + ' / ' + photoCards.length;
      if (previous) previous.disabled = photoCards.length < 2;
      if (next) next.disabled = photoCards.length < 2;
    }
    root.addEventListener('click', function (event) {
      const opener = event.target instanceof Element ? event.target.closest('[data-mt-rv-open]') : null;
      if (!opener || !root.contains(opener)) return;
      const seen = new Set();
      photoCards = filtered().filter(function (card) {
        if (!card.dataset.full || seen.has(card.dataset.photoIdx)) return false;
        seen.add(card.dataset.photoIdx); return true;
      });
      const index = photoCards.findIndex(function (card) { return card.dataset.photoIdx === opener.dataset.mtRvOpen; });
      if (index < 0) return;
      event.preventDefault(); lastFocus = opener; show(index);
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      modal.showModal(); modal.querySelector('[data-mt-rv-close]').focus();
    });
    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-mt-rv-close]')) modal.close();
      else if (event.target.closest('[data-mt-rv-prev]')) show(active - 1);
      else if (event.target.closest('[data-mt-rv-next]')) show(active + 1);
    });
    modal.addEventListener('keydown', function (event) {
      if (photoCards.length < 2) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(active - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(active + 1); }
    });
    modal.addEventListener('close', function () {
      document.documentElement.style.overflow = previousOverflow;
      image.src = 'data:,'; content.replaceChildren();
      if (lastFocus) lastFocus.focus({ preventScroll:true });
    });
  }
  function mount(scope) {
    if (scope instanceof Element && scope.matches('[data-mt-rv]')) initialise(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-mt-rv]').forEach(initialise);
  }
  window.mtReviewFeed = { mount:mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(document); }, { once:true });
  else mount(document);
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
}());
